import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/marca?${serialize(filtros)}`, { tela: 'marca' })
}

export async function get (id) {
  return httpAuth.get(`/marca/${id}`, { tela: 'marca' })
}

export async function add (dados) {
  return httpAuth.post(`/marca`, dados, { funcionalidade: 'marca_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/marca/${id}`, dados, { funcionalidade: 'marca_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/marca/${id}`, { funcionalidade: 'marca_excluir' })
}
